<template>
  <section>
    <!-- <el-dialog :visible.sync="dialogVisible_approve">
      <Approve v-if="dialogVisible_approve" @approve_submit="approve_submit" :SP_IF="SP_IF" :ApproveList="request_list"></Approve>
    </el-dialog> -->
    <div v-if="SP_IF" style="margin-bottom: 5px">
      <div style="background-color: white; padding: 30px; border-radius: 10px">
        <Approve :SP_IF="SP_IF" @approve_submit="approve_submit" :ApproveList="splist"></Approve>
      </div>
    </div>
    <!--列表-->
    <div>
      <div class="table_top_div" style="margin-bottom: 5px">
        <span style="margin-bottom: 5px; font-size: 18px; font-weight: bold; display: inline-block; color: #6170d7; vertical-align: sub">
          {{ splist.hcoName }}
        </span>
        <el-table
          border
          max-height="100%"
          v-if="splist.data.approvalDataContractDtos.length > 0 || splist.data.approvalDataPotentialDtos.length > 0"
          :data="lists"
          :span-method="objectSpanMethod"
          header-cell-class-name="header_cell_name"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%; margin-bottom: 10px"
        >
          <el-table-column
            v-if="splist.data.approvalDataContractDtos.length > 0 || splist.data.approvalDataPotentialDtos.length > 0"
            prop="productName"
            label="Category
            "
            width="150"
          ></el-table-column>
          <el-table-column v-if="splist.data.approvalDataContractDtos.length > 0" prop="jjsvQuantity" label="JJSV预估签约量" width>
            <template scope="scope">
              <!-- <span style="color: red">{{ scope.row.contractQuantity }}</span> -->
              <span :style="scope.row.jjsvQuantity == scope.row.oldJJSVQuantity ? '' : 'color: red'">
                {{ scope.row.productName == '三焦点(散+非散)' ? '/' : scope.row.jjsvQuantity }}
              </span>
            </template>
          </el-table-column>
          <el-table-column v-if="splist.data.approvalDataContractDtos.length > 0" prop="oldJJSVQuantity" label="JJSV预估签约量-原始值" width>
            <template scope="scope">
              <span>
                {{ scope.row.productName == '三焦点(散+非散)' ? '/' : scope.row.oldJJSVQuantity }}
              </span>
            </template>
          </el-table-column>
          <el-table-column v-if="splist.data.approvalDataContractDtos.length > 0" prop="contractQuantity" label="全院总签约量" width>
            <template scope="scope">
              <!-- <span style="color: red">{{ scope.row.contractQuantity }}</span> -->
              <span :style="scope.row.contractQuantity == scope.row.oldContractQuantity ? '' : 'color: red'">{{ scope.row.contractQuantity }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="splist.data.approvalDataContractDtos.length > 0" prop="oldContractQuantity" label="全院总签约量-原始值" width>
            <!-- <template scope="scope">
              <span>{{ scope.row.oldContractQuantity ? scope.row.oldContractQuantity : '空' }}</span>
            </template> -->
          </el-table-column>
          <el-table-column v-if="splist.data.approvalDataPotentialDtos.length > 0" prop="potential" label="分品类手术量" width>
            <template scope="scope">
              <span :style="scope.row.potential == scope.row.oldPotential ? '' : 'color: red'">{{ scope.row.potential }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="splist.data.approvalDataPotentialDtos.length > 0" prop="oldPotential" label="分品类手术量-原始值" width>
            <!-- <template scope="scope">
              <span>{{ scope.row.oldPotential ? scope.row.oldPotential : '空' }}</span>
            </template> -->
          </el-table-column>
        </el-table>
        <el-table
          border
          max-height="100%"
          v-if="splist.data.approvalDataDipDto.length > 0 || splist.data.approvalDataDrgDto.length > 0"
          :data="lists"
          :span-method="objectSpanMethod"
          header-cell-class-name="header_cell_name"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%; margin-bottom: 10px"
        >
          <el-table-column v-if="splist.data.approvalDataDipDto.length > 0" prop="dip" label="DIP费用（不含手术费，只是晶体费用）" width>
            <template scope="scope">
              <!-- <span style="color: red">{{ scope.row.dip }}</span> -->
              <span :style="scope.row.dip == scope.row.oldDip ? '' : 'color: red'">{{ scope.row.dip }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="splist.data.approvalDataDipDto.length > 0" prop="oldDip" label="DIP费用（不含手术费，只是晶体费用）-原始值" width>
            <!-- <template scope="scope">
              <span>{{ scope.row.oldDip ? scope.row.oldDip : '空' }}</span>
            </template> -->
          </el-table-column>
          <el-table-column v-if="splist.data.approvalDataDrgDto.length > 0" prop="drg" label="DRG费用（不含手术费，只是晶体费用）" width>
            <template scope="scope">
              <!-- <span style="color: red">{{ scope.row.drg }}</span> -->
              <span :style="scope.row.drg == scope.row.oldDrg ? '' : 'color: red'">{{ scope.row.drg }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="splist.data.approvalDataDrgDto.length > 0" prop="oldDrg" label="DRG费用（不含手术费，只是晶体费用）-原始值" width>
            <!-- <template scope="scope">
              <span>{{ scope.row.oldDrg ? scope.row.oldDrg : '空' }}</span>
            </template> -->
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import { cataractnnvmp_getlist, cataractnnvmp_submit, cataractnnvmp_approvalclaim, cataractnnvmp_approvalcancel } from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import Toolbar from '@/components/Toolbar'
import Approve from '@/components/Approve'

export default {
  components: { Toolbar, quillEditor, Approve },
  data() {
    return {
      lists: [],
      splist: {
        data: {
          approvalDataContractDtos: [],
          approvalDataDipDto: [],
          approvalDataDrgDto: [],
          approvalDataPotentialDtos: [],
        },
      },
      dialogVisible_approve: false,
      SP_IF: '',
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      pageNumber: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    back_url() {
      //   this.$router.replace({ path: this.$route.query.back_url })
      this.$router.go(-1)
    },
    open_approve(res) {
      this.request_list = res
      this.dialogVisible_approve = true
      console.log(this.request_list)
    },
    async approve_submit(res) {
      if (res.CH_IF) {
        var { data } = await cataractnnvmp_approvalcancel(res)
      } else {
        var { data } = await cataractnnvmp_approvalclaim(res)
      }
      if (data.code == 200) {
        this.back_url()
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    async save(res) {
      res.dip = res.details[0].dip
      res.drg = res.details[0].drg
      res.potential = res.details[0].all_potential
      console.log(res)
      const { data } = await cataractnnvmp_submit(res)
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 7 || columnIndex === 8) {
        if (rowIndex % 16 === 0) {
          return {
            rowspan: 16,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
    },
    // 合并数据
    mergeData(data) {
      //   let spanArr = []
      //   let concatSpanArr = []
      let merge = {}
      data.map((item, index) => {
        merge = {
          all_potential: item.potential,
          dip: item.dip,
          drg: item.drg,
        }
        item.details.map((item2, index2) => {
          item2 = { ...item2, ...merge }
          item.details[index2] = item2
        })
      })
      return data
      //   console.log(data)
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.pageNumber = this.pageNumber
      console.log(para)
      // return
      //   let para = {
      //     pageNumber: this.pageNumber,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      cataractnnvmp_getlist(para).then((res) => {
        this.total = res.data.data.dataCount
        console.log(this.tabel_list)
        this.listLoading = false
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    // this.getModules()
    console.log(this.$route.query)
    var list = JSON.parse(this.$route.query.hco_list)
    this.splist = list

    if (list.data.approvalDataDipDto.length > 0 || list.data.approvalDataDrgDto.length > 0) {
      if (list.data.approvalDataDipDto.length > 0 && list.data.approvalDataDrgDto.length > 0) {
        this.lists = [{ ...list.data.approvalDataDipDto[0], ...list.data.approvalDataDrgDto[0] }]
      } else {
        this.lists = list.data.approvalDataDipDto.length > 0 ? list.data.approvalDataDipDto : list.data.approvalDataDrgDto
      }
    }
    if (list.data.approvalDataContractDtos.length > 0 || list.data.approvalDataPotentialDtos.length > 0) {
      if (list.data.approvalDataContractDtos.length > 0 && list.data.approvalDataPotentialDtos.length > 0) {
        var num =
          list.data.approvalDataContractDtos.length == 0 ? list.data.approvalDataPotentialDtos.length : list.data.approvalDataContractDtos.length
        for (var i = 0; i < num; i++) {
          this.lists.push({ ...list.data.approvalDataContractDtos[i], ...list.data.approvalDataPotentialDtos[i] })
        }
      } else {
        this.lists = list.data.approvalDataContractDtos.length > 0 ? list.data.approvalDataContractDtos : list.data.approvalDataPotentialDtos
      }
      console.log(this.lists)
    }

    this.SP_IF = this.$route.query.status

    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
  },
}
</script>

<style scoped></style>
